import React from 'react';
import Skeleton from 'components/commercetools-ui/atoms/skeleton';
import Preview from 'components/commercetools-ui/organisms/checkout/components/steps/previews/wrapper';
import { useFormat } from 'helpers/hooks/useFormat';

const AmazonpayReviewPageSkeleton = () => {
  const sectionMainClass =
    'flex items-center justify-between rounded-t-sm border border-neutral-400 bg-white p-12 transition lg:rounded-t-md lg:bg-white lg:px-36 lg:py-24';
  const { formatMessage: formatCheckoutMessage } = useFormat({ name: 'checkout' });
  const { formatMessage: formatCartMessage } = useFormat({ name: 'cart' });

  return (
    <div className="w-[100%] flex-row-reverse items-start gap-24 lg:flex">
      <div className="bg-white px-16 md:px-24 lg:w-[30%] lg:rounded-md lg:p-36 lg:px-20 xl:px-48">
        <div className="py-16 lg:py-0">
          <div className="relative font-body font-bold uppercase md:text-23 lg:text-20 xl:text-23">
            {formatCartMessage({ id: 'order.summary', defaultMessage: 'Order summary' })}
          </div>

          <div className="mb-16 hidden gap-8 border-b border-neutral-400 py-24 pt-16 lg:grid">
            <div className="mb-16 border-y border-neutral-400 py-16">
              <div className="relative h-15 w-[140px]">
                <Skeleton></Skeleton>
              </div>
            </div>
            <div className="flex items-center justify-between text-13 font-light capitalize text-secondary-black">
              <div className="relative mb-5 h-15 w-[50px]">
                <Skeleton></Skeleton>
              </div>
              <div className="relative mb-5 h-15 w-[40px]">
                <Skeleton></Skeleton>
              </div>
            </div>
            <div className="flex items-center justify-between text-13 font-light capitalize text-secondary-black">
              <div className="relative mb-5 h-15 w-[140px]">
                <Skeleton></Skeleton>
              </div>
              <div className="relative mb-5 h-15 w-[40px]">
                <Skeleton></Skeleton>
              </div>
            </div>
            <div className="flex items-center justify-between text-13 font-light capitalize text-secondary-black">
              <div className="relative mb-5 h-15 w-[100px]">
                <Skeleton></Skeleton>
              </div>
              <div className="relative mb-5 h-15 w-[40px]">
                <Skeleton></Skeleton>
              </div>
            </div>
          </div>
          {/** mobile view*/}
          <div className="lg:hidden">
            <div className="mt-16 border-y border-neutral-400 py-16 md:pt-16 lg:mb-16">
              <div className="relative h-20 w-[80px]">
                <Skeleton></Skeleton>
              </div>
            </div>
            <div className="border-b border-neutral-400 py-16 md:pt-16 lg:mb-16">
              <div className="relative h-20 w-[120px]">
                <Skeleton></Skeleton>
              </div>
            </div>
          </div>
          {/** */}
          <div className="mt-24 hidden items-center justify-between font-medium md:pb-20 lg:flex">
            <div className="relative h-15 w-[30px]">
              <Skeleton></Skeleton>
            </div>
            <div className="relative h-25 w-[70px]">
              <Skeleton></Skeleton>
            </div>
          </div>
          <div className="relative hidden h-44 w-[100%] lg:block">
            <Skeleton></Skeleton>
          </div>

          {/** */}
        </div>
      </div>

      <div className="px-16 md:px-24 lg:w-[70%] lg:grow lg:px-0">
        <div className="flex flex-col gap-24 lg:bg-neutral-200">
          <div className="bg-white">
            <div className={sectionMainClass}>
              <div className="flex cursor-default items-center gap-12 lg:gap-16">
                <h5 className="text-primary-black transition lg:text-18 lg:text-primary-black">
                  {formatCheckoutMessage({ id: 'delivery', defaultMessage: 'Delivery' })}
                </h5>
              </div>
              <span>
                <div className="relative mb-10 h-15 w-[30px]">
                  <Skeleton></Skeleton>
                </div>
              </span>
            </div>
            <div>
              <Preview>
                <div className="border-neutral-400 lg:border lg:p-16">
                  <div className="py-18 pl-18">
                    <div className="block gap-10 md:flex">
                      <div className="w-full md:w-[40%]">
                        <div className="relative mb-15 h-20 w-[220px]">
                          <Skeleton></Skeleton>
                        </div>
                        <div className="text-14 font-light leading-5 text-secondary-black">
                          <div className="relative mb-10 h-15 w-[150px]">
                            <Skeleton></Skeleton>
                          </div>
                          <div className="relative mb-10 h-15 w-[180px]">
                            <Skeleton></Skeleton>
                          </div>
                          <div className="relative mb-10 h-15 w-[150px]">
                            <Skeleton></Skeleton>
                          </div>
                        </div>
                      </div>
                      <div className="mt-30 w-full md:mt-auto md:w-[40%]">
                        <div className="relative mb-15 h-20 w-[220px]">
                          <Skeleton></Skeleton>
                        </div>
                        <div className="text-14 font-light leading-5 text-secondary-black">
                          <div className="relative mb-10 h-15 w-[150px]">
                            <Skeleton></Skeleton>
                          </div>
                          <div className="relative mb-10 h-15 w-[180px]">
                            <Skeleton></Skeleton>
                          </div>
                          <div className="relative mb-10 h-15 w-[150px]">
                            <Skeleton></Skeleton>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Preview>
            </div>
          </div>
          {/** Section Paymant */}
          <div className="bg-white">
            <div>
              <div className={sectionMainClass}>
                <div className="flex cursor-default items-center gap-12 lg:gap-16">
                  <h5 className="text-primary-black transition lg:text-18 lg:text-primary-black">
                    {formatCheckoutMessage({ id: 'payment', defaultMessage: 'Payment' })}
                  </h5>
                </div>
                <span>
                  <div className="relative mb-10 h-15 w-[30px]">
                    <Skeleton></Skeleton>
                  </div>
                </span>
              </div>
              <Preview>
                <div className={`border border-neutral-400 p-16 md:px-20 md:py-24 `}>
                  <div className="flex items-center justify-between py-18 pl-18 ">
                    <div>
                      <div className="lg-[330px] relative h-20 w-[210px]">
                        <Skeleton></Skeleton>
                      </div>
                    </div>
                  </div>
                </div>
              </Preview>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmazonpayReviewPageSkeleton;
